import { Observable } from 'rxjs';
import { Dashboard } from './../../shared/interceptors/token.interceptors';
/**
 * De ahora en adelante, los empleados de Unidrogas se loggearán por acá
 * BANNERS, PRODUCTOS EN TELEFERIA, PQRS, LABORATORIOS, CERTIFICADOS
 */
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginWebService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');

  /**
   * Mapa de roles
   *
   * Acá se añaden los códigos de roles nuevos.
   * Este mapa de roles se compara con el array de roles que llega del backend.
   *
   * Esto se realiza para tener un mejor control de los roles (para marcarlos true o false)
   */
  rolesMap: RolesIDs = {
    adminTalentoHumano: 1003,
    talentoHumano: 1004,
    adminContenido: 1005,
    adminUsersRole: 1006,
    empleadoGeneralRole: 1007,
    adminCurriculumRole: 1008,
    adminPQR: 1009,
    adminBannersRole: 1010,
    trabajadorComprasRole: 1013,
    usuarioBodega: 1014,
    adminContenidoEmpleados: 1015,
    adminDeposito: 1017,
    recepcionista: 1018,
    adminCensantia: 1019
  };

  constructor(private _http: HttpClient, private router: Router) { }
  /**
   * Iniciar sesión al usuario
   * Loggeo del usuario al dashboard web
   * @param loginForm Objeto que contiene usuario y contraseña
   */
  loginUser(loginForm) {
    return this._http.post(environment.dashboard_web.login, loginForm);
  }
  /**
   * Olvidé la contraseña
   * Envía un enlace de recuperación al correo
   */
  forgotPassword(forgotPasswordForm: any): Observable<any> {
    return this._http.post(environment.dashboard_web.POST_FORGOT_PASSWORD_EMPLOYEE, forgotPasswordForm);
  }
  /**
   * Actualiza la contraseña tras haber recibido un código por correo
   * @returns
   */
  updatePassword(updatePasswordForm: any): Observable<any> {
    return this._http.post(environment.dashboard_web.POST_UPDATE_PASSWORD_EMPLOYEE, updatePasswordForm);
  }
  /**
   * Se coloca el token en el localstorage
   */
  setToken(token) {
    localStorage.setItem('token', token);
  }
  /**
   * 1er paso a la hora de iniciar sesión
   * Se chequea si el usuario realmente es poseedor del correo
   * El backend enviará si puede continuar
   */
  validateUnidrogasEmployee() {
    return this._http.get(environment.dashboard_web.USER_VALIDATION, {
      headers: this.headers,
    });
  }
  /**
   * 2do caso A | El usuario tiene confirmado su correo
   * A la hora de iniciar sesión
   * Si el usuario tiene vali
   * Chequeo de si el usuario posee permiso para el dashboard web o no
   */
  userPermission() {
    return this._http.get(environment.dashboard_web.roles, {
      headers: this.headers,
    });
  }
  /**
   * 2do caso B | El usuario no tiene confirmado su correo
   * A la hora de iniciar sesión, al usuario se le mostrará un modal en donde
   * debe confirmar el envío del código para validar su correo
   */
  userSendMailCodeValidation(employee_pk, mail) {
    const body = {
      primary_key: employee_pk,
      correo: mail,
    };

    return this._http.post(environment.dashboard_web.USER_SEND_MAIL_VALIDATION_CODE, body, { headers: this.headers });
  }
  /**
   * 3er caso B | El usuario recibió el código en su correo
   * El usuario digita el código recibido del correo y lo envía para validar la cuenta
   * @param code Codigo recibido en el correo
   */
  userSendReceivedCode(code) {
    return this._http.post(
      environment.dashboard_web.USER_SEND_RECEIVED_VALIDATION_CODE,
      { codigo: code },
      { headers: this.headers }
    );
  }
  /**
   * Se colocan los permisos del usuario en el localStorage en base64
   * Se hace string el array que llega del backend para, en el dashboard,
   * hacer un for que chequee los permisos que posee
   */
  setPermissionsToGoDashboard(permissions) {
    const arrayPermissions = [];
    // Se chequea si es un número o array
    if (permissions.constructor === Number) {
      arrayPermissions.push(permissions);
    } else if (permissions.constructor === Array) {
      permissions.forEach((element) => {
        arrayPermissions.push(element);
      });
    }
    console.log('el num');

    console.log(arrayPermissions);

    // Se hace string para guardarse en el localStorage
    localStorage.setItem('uni_perms', window.btoa(JSON.stringify(arrayPermissions)));


    arrayPermissions[0] != 1022 ? this.goToDashboard() : this.router.navigate(['/aspirantes']);
  }
  /**
   * Retorna un array con los tipos de rol que posee el usuario
   * El array se encuentra codificado en base64 con btoa
   * Se decodifica con atob
   */
  getUserRoles() {
    if (localStorage.getItem('uni_perms')) {
      const perms = JSON.parse(atob(localStorage.getItem('uni_perms')));
      return perms;
    } else {
      return null;
    }
  }
  /**
   * Retorna cada permiso que posee el usuario con booleanos
   *
   * Toma el mapa de roles y se compara con el mapa de roles @param this.rolesMap
   * Se iteran y se marca true el permiso que se encuentre
   */
  returnUserRoles() {
    // Permisos del usuario
    const userPermissions = this.getUserRoles();
    // Permisos inicializados en false
    const boolUserPermissions: UserRoles = {
      recepcionista: false,
      adminDeposito: false,
      adminTalentoHumano: false,
      adminContenidoEmpleados: false,
      talentoHumano: false,
      adminContenido: false,
      adminUsersRole: false,
      empleadoGeneralRole: false,
      adminCurriculumRole: false,
      adminPQR: false,
      adminBannersRole: false,
      trabajadorComprasRole: false,
      usuarioBodega: false,
      adminCensantia: false
    };
    // Se itera en el array de permisos guardados en el localStorage
    userPermissions.forEach((x: number) => {
      // Se itera en el objeto (array con Object.values)
      Object.values(this.rolesMap).forEach((value, index) => {
        // console.log(Object.keys(this.rolesMap)[index]);

        if (value == x) {
          boolUserPermissions[Object.keys(this.rolesMap)[index]] = true;
        }
      });
    });
    console.log(boolUserPermissions);

    return boolUserPermissions;
  }
  /**
   * Ir al dashboard correspondiente dependiendo del rol o roles que tenga
   */
  goToDashboard() {
    this.router.navigate(['/dashboard/empleado']);
  }
}

/**
 * INTERFACES DE ROLES
 *
 * Cuando haya un nuevo rol, se debe añadir a las interfaces
 * de manera que en las plantillas HTML se pueda utilizar de la
 * siguiente manera:
 *
 * *ngIf="arrRoles.rol"
 */
export interface RolesIDs {
  adminTalentoHumano: number;
  talentoHumano: number;
  adminContenido: number;
  adminUsersRole: number;
  empleadoGeneralRole: number;
  adminCurriculumRole: number;
  adminPQR: number;
  adminBannersRole: number;
  trabajadorComprasRole: number;
  usuarioBodega: number;
  adminContenidoEmpleados: number;
  adminDeposito: number;
  recepcionista: number;
  adminCensantia: number
}
export interface UserRoles {
  recepcionista: boolean;
  adminDeposito: boolean;
  adminTalentoHumano: boolean;
  talentoHumano: boolean;
  adminContenido: boolean;
  adminContenidoEmpleados: boolean;
  adminUsersRole: boolean;
  empleadoGeneralRole: boolean;
  adminCurriculumRole: boolean;
  adminPQR: boolean;
  adminBannersRole: boolean;
  trabajadorComprasRole: boolean;
  usuarioBodega: boolean;
  adminCensantia: boolean
}
